/* eslint-disable @angular-eslint/prefer-inject */
import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificacionComponent } from '../notificacion/notificacion.component';

export interface NotificacionDialogData {
  modoOscuro: boolean;
}

@Component({
  selector: 'app-notificacion-dialog',
  template: `
    <app-notificacion
      [modoOscuro]="data.modoOscuro"
      (cerrarPanel)="cerrar()"
      (notificacionLeida)="onNotificacionLeida($event)"
      (marcarTodasLeidasEvent)="onMarcarTodasLeidas()"
    ></app-notificacion>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 420px;
        max-width: calc(100vw - 40px);
        min-height: 400px;
        max-height: 80vh;
        background: var(--md-sys-color-surface-container-low, #f9f9ff);
        overflow: hidden;
      }

      :host-context(.dark) {
        background: #1f293c;
        box-shadow:
          0 8px 28px rgba(0, 0, 0, 0.25),
          0 4px 12px rgba(0, 0, 0, 0.2),
          0 0 1px rgba(255, 255, 255, 0.05);
      }

      @media (max-width: 768px) {
        :host {
          width: 100vw;
          max-width: 100vw;
          height: 100vh;
          max-height: 100vh;
          border-radius: 0;
          margin: 0;
        }
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule, NotificacionComponent],
})
export class NotificacionDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<NotificacionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NotificacionDialogData,
  ) {}

  ngOnInit() {
    this.dialogRef.updateSize('420px', 'auto');
  }

  onNotificacionLeida(_notificacionId: string) {
    // to do
  }

  onMarcarTodasLeidas() {
    // to do
  }

  cerrar() {
    this.dialogRef.close();
  }
}
